import { Component, Input, OnInit } from '@angular/core';

import { CmsService } from '~/cms/services/cms/cms.service';

import { LogoTypeEnum } from '~/component/logo/enums/logo-type.enum';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
})
export class LogoComponent implements OnInit {
  @Input() public alt = '';
  @Input() public height?: number;
  @Input() public name = LogoTypeEnum.Regular;

  public logoSrc: string;

  constructor(private readonly cmsService: CmsService) {}

  public ngOnInit(): void {
    this.cmsService
      .getLogo(this.name)
      .subscribe((logoPath) => (this.logoSrc = logoPath));
  }

  public get logoStyle(): object {
    if (!this.height) {
      return {};
    }

    return {
      height: `${this.height}px`,
    };
  }
}
